/** `DEPOSIT` is money received for the party, `WITHDRAWAL` money paid out of its funds. */
export type PartyAssetTransferType = 'DEPOSIT' | 'WITHDRAWAL';

export const TRANSFER_TYPES: PartyAssetTransferType[] = ['DEPOSIT', 'WITHDRAWAL'];

/** One client asset record, as every read returns it. A draft may lack any value but its case's. */
export interface PartyAsset {
    id: number;
    /** The fund account's name, as configured when the record was booked. */
    fundAccount: string | null;
    party: { id: number; name: string | null } | null;
    matter: { id: number; caseNumber: string | null; name: string | null; isConfidential: boolean | null } | null;
    note: string | null;
    bankTransferDate: string | null;
    transferType: PartyAssetTransferType | null;
    /** Signed by `transferType`: negative for a withdrawal. */
    transferAmount: number | null;
    currency: string | null;
    createdAt: string;
    isDraft?: boolean;
}

/**
 * The create and update body: the amount is always positive, and the backend signs it by `transferType`. Only a
 * draft is saved with values missing.
 */
export interface PartyAssetRequest {
    fundAccount: string | null;
    partyId: number | null;
    matterId: number | null;
    note: string;
    bankTransferDate: string | null;
    transferType: PartyAssetTransferType | null;
    transferAmount: number | null;
    currency: string | null;
}

export interface PartyAssetCurrencyTotal {
    currency: string;
    amount: number;
}

export interface PartyAssetFundAccount {
    name: string;
    active: boolean;
    /** A record is booked on it, which locks its name. */
    inUse: boolean;
    /** Its records sum to a non-zero amount in some currency, which keeps it from being deactivated. */
    holdsFunds: boolean;
}
